
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import {Fetch} from "../../utils/storage"
import {GetInfo} from "../../utils/login"

export default {
name: 'user-center',
components: {
Group,
Cell
},
data () {
return {
HeadImg:'http://img.135q.com/2015-03/02/14252955960002.jpg',
NickName:'',
}
},
async created () {
this.NickName = Fetch('NickName')
this.HeadImg = Fetch('HeadImg')

if(!this.NickName || !this.HeadImg) {
let user = await GetInfo()
this.NickName = user.NickName
this.HeadImg = user.HeadImg
}

},
methods: {
handleClickCell(path) {
this.$router.push(path)
},
handleContact() {
this.$vux.confirm.show({
theme: 'ios',
content: '<span style="font-size:20px">确认拨打客服热线？</span>',
onConfirm() {
window.location.href = 'tel://' + "17610510599"
}
})

}
}
}
